import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
interface QueryFiltersProps {
	initialValues?: { [key: string]: string[] | string };
}

const parseSearchFilters = (search: string) => {
	if (!search) return {} as { [key: string]: string[] | string };

	const url = new URLSearchParams(search);
	const parsed: { [key: string]: string[] | string } = {};

	for (const [key, value] of url) {
		try {
			parsed[key] = JSON.parse(value);
		} catch {
			parsed[key] = value;
		}
	}

	return parsed;
};

function useQueryFilters(props: QueryFiltersProps) {
	const { initialValues } = props;
	const { search, pathname } = useLocation();
	const router = useHistory();

	const [filters, setFilters] = useState<{
		[key: string]: string[] | string;
	}>(() => {
		if (search) {
			return parseSearchFilters(search);
		}

		return initialValues ?? {};
	});

	useEffect(() => {
		if (!search && initialValues) {
			let initial: { [key: string]: string } = {};
			for (const [key, value] of Object.entries(initialValues)) {
				if (value) {
					initial[key] = JSON.stringify(value);
				}
			}

			const newParams = new URLSearchParams(initial);
			router.push(pathname + (newParams ? "?" + newParams : ""));
		}
	}, [initialValues, pathname, router, search]);

	useEffect(() => {
		setFilters(parseSearchFilters(search));
	}, [search]);

	const update = useCallback(
		(newValues: { [key: string]: string[] | string }, resetOld?: boolean) => {
			if (!newValues) return;

			let urlValues: { [key: string]: string } = {};

			for (const [key, value] of Object.entries(newValues)) {
				if (key === "tab") {
					urlValues[key] = value[0];
				} else if (value && value.length > 0) {
					urlValues[key] = JSON.stringify(value);
				}
			}
			if (!resetOld)
				for (const [key, value] of Object.entries(filters)) {
					if (!urlValues.hasOwnProperty(key)) {
						urlValues[key] = JSON.stringify(value);
					}
				}

			const newParams = new URLSearchParams(urlValues);
			router.push(pathname + (newParams ? "?" + newParams : ""));
		},
		[filters, pathname, router]
	);

	const clear = () => router.push(pathname);

	return { update, clear, filters };
}

export default useQueryFilters;
